
import { type DebugSettings, ApiTypes, OktaApiEnvironment } from '@ca.vmedia.tv/domains';
import { Strings } from "@/locales/types/enums/strings";

export type TDevModeSettingsValue = ApiTypes | OktaApiEnvironment | string

interface IValues {
    title: string;
    value: TDevModeSettingsValue;
}

export interface IDevModeSettingsList {
    title: string;
    description: string;
    key: keyof DebugSettings;
    values: (IValues)[];
}

export const listItems: IDevModeSettingsList[] = [
    {
        title: Strings.DEVMODE_ENVIRONMENT_API_TITLE,
        description: Strings.DEVMODE_ENVIRONMENT_API_DESCRIPTION,
        key: 'api',
        values: [
            {
                title: Strings.DEVMODE_ENVIRONMENT_API_PROD,
                value: ApiTypes.PROD
            },
            {
                title: Strings.DEVMODE_ENVIRONMENT_API_PREVIEW,
                value: ApiTypes.PREVIEW
            }
        ]
    },
    {
        title: Strings.DEVMODE_ENVIRONMENT_OKTA_API_TITLE,
        description: Strings.DEVMODE_ENVIRONMENT_OKTA_API_DESCRIPTION,
        key: 'oktaApi',
        values: [
            {
                title: Strings.DEVMODE_ENVIRONMENT_OKTA_API_PROD,
                value: OktaApiEnvironment.PROD
            },
            //TODO: Uncomment this block when Fizz fixes the CORS issue for https://ppx-auth-fizz.videotron.com/oauth2/aus6vnd01nucYl1VX1d7/v1/authorize 
            /* {
                title: Strings.DEVMODE_ENVIRONMENT_OKTA_API_PREVIEW,
                value: OktaApiEnvironment.PREVIEW
            } */
        ]
    },
];